import ApiClient from "../../../../methods/api/apiClient";
import ChatbotApiClient from "../../../../methods/api/chatbotapiClient";
import loader from "../../../../methods/loader";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const PromptTab = (props) => {
  const user = useSelector(state => state.user);

  const [text, setText] = useState("");
  const GetPrompts=()=>{
    loader(true);
    ApiClient.get(`prompt/listing`,{userId:user?.id||user?._id}).then(res=>{
      if(res.success){
setText(res?.data?.prompt)
      }
      loader(false);
    })
  }
  useEffect(()=>{
GetPrompts()
  },[])

  const handleTextChange = (event) => {
    setText(event.target.value);
  };

  const handleSubmit = async () => {
    loader(true);

    const payload = {
      userId: user?.id||user?._id,
      prompt: text
    };

    try {
      const res = await ChatbotApiClient.post(`prompt/create`, payload);
      if (res.success) {
        swal({
          text: "Instructions Saved Successfully!",
          icon: "success",
          className: "smallModal"
        });
      }
    } catch (error) {
      swal({
        text: "Failed to save instructions",
        icon: "error",
        className: "smallModal"
      });
    } finally {
      loader(false);
    }
  };

  return (
    <div className="w-full border border-t-0 rounded-b-2xl bg-white p-5 lg:p-8">
      <div className="space-y-6">
        
        {/* Label */}
        <p className="block text-sm text-gray-700">
          Custom Instructions for your chatbot
        </p>

        {/* Textarea */}
        <textarea
          value={text}
          onChange={handleTextChange}
          className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-[#115B9D] focus:ring-2 focus:ring-[#115B9D]/20 outline-none transition-all"
          rows="16"
          placeholder="Enter instructions for your chatbot..."
        />
{!text?<div className="text-left text-red-400">Instructions are required to save.</div>:null}
        {/* Note */}
        <div className="bg-[#115B9D17] rounded-lg p-4 flex gap-3">
  
  {/* Icon */}
  <div className="flex-shrink-0">
    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#115b9d29]">
      <svg
        className="w-4 h-4 text-[#115B9D]"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
      </svg>
    </div>
  </div>

  {/* Content */}
  <div className="space-y-1">
    <p className="text-sm font-semibold text-[#115B9D]">
      How it works
    </p>
    <p className="text-sm text-[#115B9D] leading-relaxed">
      These instructions are automatically applied in the backend and guide how your chatbot responds. 
      They act as training rules for your chatbot used in scripts, ensuring responses follow your defined behavior.
    </p>
  </div>

</div>

        {/* Save Button */}
        <div className="flex justify-end">
          <button
            onClick={handleSubmit}
            disabled={!text}
            className="px-8 py-3 bg-[#115B9D] text-white rounded-xl hover:bg-opacity-80 transition-colors shadow-sm hover:shadow-md"
            type="button"
          >
            Save
          </button>
        </div>

      </div>
    </div>
  );
};

export default PromptTab;